import { render } from "./ShopImagesUpload.vue?vue&type=template&id=095279bc&scoped=true"
import script from "./ShopImagesUpload.vue?vue&type=script&lang=js"
export * from "./ShopImagesUpload.vue?vue&type=script&lang=js"

import "./ShopImagesUpload.vue?vue&type=style&index=0&id=095279bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095279bc"]])

export default __exports__